export default {
  language: '语言',
  common: {
    cancel: '取消',
    fieldEmpty: '该字段不能为空。',
    loading: '载入中...',
    username: '用户名',
    password: '密码',
    rpassword: '重复输入密码',
    mobile: '手机号码',
    email: '电子邮件',
    login: '登录',
    signup: '报名',
    back: '后退',
    next: '下一个',
    submit: '提交',
    continue: '继续',
    close: '关闭',
    leg: '腿',
    getFee: 'GET 费用',
    get: 'GET',
    serviceFee: '服务费',
    militaryClearance: '军事许可',
    endDateMust: '结束日期必须晚于开始日期。',
    maxDurationCharter: '包机预订的最长持续时间为 {time}。',
    invalidDateRange: '日期范围无效。',
    fieldRequired: '{field} 字段是必需的。',
    invalidEmail: '电子邮件字段必须是有效的电子邮件。'
  },
  searchForm: {
    bookARide: '预订包机服务',
    bookACharter: '按小时预订包机',
    requestARide: '立即叫车',
    bookCharter: '预订包机服务',
    enterPickup: '输入您的取件地点：',
    extraStop: '加站:',
    enterDropoff: '输入您的下车地点：',
    whenDoYou: '你什么时候需要搭车？',
    untilWhen: '直到什么时候需要它？',
    getAQuote: '获取报价',
    gettingQuote: '正在获取报价...',
    editCancel: '编辑/取消骑行',
    editRsvp: '编辑预订',
    trackVehicle: '追踪您的车辆',
    trackRsvp: '曲目预约',
    or: '或者',
    haveCorporate: '您有公司帐户吗？',
    loginSignup: '在这里登录/注册',
    not: '不是',
    signout: '登出',
    youAreLogged: '您以个人帐户登录。',
    locationPlaceholder: '例如机场，家庭等',
    startDateGreater: '开始日期必须比当前时间晚 {WebTimeBuffer} 分钟。',
    manualPickup: '手动取件位置文本输入不够精确',
    unablePinpointPickup: '无法查明您想要的取件地点。',
    manualLocation: '手动位置文本输入不够精确',
    unablePinpointExtra: '无法确定您想要的额外停靠点。',
    manualDropoff: '手动下车位置文本输入不够精确',
    unablePinpointDropoff: '无法查明您想要的下车地点。',
    noAvailableService: '没有可用的服务类型',
    sorryService: '对不起！我们的服务在此区域尚不可用。',
    youCanAdd: '您可以添加一个额外的停靠点。',
    airports: '飞机场',
    themeParks: '主题公园',
    ports: '港口',
    hotel: '饭店',
    universities: '大学',
    setMap: '在地图上设置',
    map: '地图',
    setLocation: '设置位置',
    sorry: '对不起',
    coudntLocate: '我们找不到',
    pleaseFillForm: '请填写此表格以创建一个帐户',
    recommendedSize: '推荐尺寸：',
    corporateName: '公司名称',
    website: '网站',
    billingInfo: '账单信息',
    creditCard: '信用卡 ＃',
    cardName: '持卡人姓名',
    exp: '期满',
    cvv: '地址',
    addr: '地址',
    addr1: '地址1',
    addr2: '地址2',
    city: '城市',
    state: '状态',
    nonUs: '非美国',
    zip: '邮政编码',
    country: '国家',
    reviewDetails: '查看您的详细信息',
    submitting: '提交中。请稍等...',
    thankYouSignup: '谢谢您注册！',
    yourCorporate: '您的公司资料正在等待管理员的批准。您的帐户获得批准后，您会收到通知。',
    ok: '好的',
    pleaseUpload: '请上传图片。',
    spaceNotAllowed: '不允许有空间',
    validEmail: '请输入有效的电子邮件地址。',
    passwordNotMatch: '密码和重复密码不匹配。',
    uploadImgFail: '上传图片失败。请再试一遍。',
    serviceNA: '服务不可用'
  },
  serviceSelect: {
    changeSelect: '查看更多服务选项',
    future: '将来',
    rightNow: '现在',
    selectAsap: '如果您希望尽快上车，请选择此选项.',
    dateAsapLyft: 'ASAP 行程不提供额外停靠点，额外停靠点将被自动移除。',
    pickAsap: '尽快接我',
    selectStartDate: '选择开始日期：',
    selectEndDate: '选择结束日期：',
    selectPickupDate: '选择接送日期：',
    flightArrival: '航班到达日期',
    flightDeparture: '航班出发日期',
    selectStartTime: '选择开始时间：',
    selectEndTime: '选择结束时间：',
    selectPickupTime: '选择接送时间：',
    arrivalTime: '选择您的航班到达时间',
    departureTime: '选择您的航班起飞时间',
    mustBe: '从现在起必须至少为 {pickuptimeRule}',
    apply: '申请',
    useSuggested: '使用建议时间',
    timeBufferError1: '所选时间必须比当前时间长 {webTimeBuffer} 分钟。',
    timeBufferError2: '不得设置过去的飞行 {direction} 时间',
    endDateMust: '结束日期必须晚于开始日期。',
    chooseAirline: '从列表中选择一家航空公司',
    chooseFlight: '从列表中选择一个航班',
    thisDomestic: '这是国内航班',
    cantFindFlight: '单击此处输入您的航班号',
    typeFlight: '输入航班号',
    search: '搜索',
    provideFlight: '请提供您的航班号。',
    rideDetails: '1. 您的骑行细节',
    selectService: '2. 选择一项服务',
    clickImage: '点击图片查看大图',
    dontWantRT: '我不想预订往返。',
    rtDetails: '3. 往返详细信息',
    isNotAvailable: '在您的回程日期不可用。 请尝试改用其他服务或更改回程日期。',
    chooseService: '4. 选择一项服务',
    returnLater: '以后再回来吗？',
    bookRt: '预订回程',
    suggestedPickupTime: '建议上车时间',
    firstTrip: '第一次旅行',
    toMakeSurePickup: '为了确保我们能在您到达机场后立即接您，以下是建议的接送时间：',
    toMakeSureFlight: '为确保您不会错过航班，建议的接载时间为：',
    yesSuggested: '是的，请使用建议的接送时间。',
    noKeep: '不，我想保留接送时间。',
    suggestedPickupTimeReturn: '建议回程的接载时间',
    wereSorry: '很抱歉，在您选择的日期和时间没有可用的游乐设施。',
    legErrorFields: '第{leg}条：请填写所有必填字段！',
    pleaseSelectService: '请选择一项服务。',
    legSelectService: '腿{leg}：请选择一项服务。',
    availableOnlyFrom: '仅可从',
    save: '救',
    bySharingRide: '通过分享你的旅程。',
    ifWeFind: '如果我们找到至少 1 个人与您分享您的行程，我们将退款给您',
    atTheTime: '在您的旅行结束时。',
    iWantTo: '我想与其他人分享我的旅程',
    startDate: '开始日期',
    endDate: '结束日期',
    flightArrive: '您的航班什么时候到达？',
    flightDepart: '您的航班什么时候出发？',
    whenRide: '您什么时候需要搭车？',
    flightInfo: '航班信息',
    pax: '乘客人数',
    choose: '选择',
    luggage: '值机行李',
    carryOns: '包括随身行李',
    aptGate: '公寓/门号',
    optional: '（选修的）',
    arrivalTimes: '提供的到达时间仅是基于当前交通数据的估算值。',
    forReturnTrip: '*回程时，您将被接送',
    scheduled: '预定的',
    scheduledAsap: '预定或尽快',
    selectFlightTime: '请先设置飞行时间。',
    inputFlightNo: '请选择或输入航班号',
    bestValue: '最超值',
    fastest: '最快的',
    plusApplicableFees: '加上适用的费用',
    onewayFare: '单程票价',
    serviceAirportAvailable1: '{service} 服务仅在 {start} 至 {end} 的机场提供。',
    serviceAirportAvailable2: '{service} 服务目前不适用于机场接送。',
    tryService: '请尝试我们的 <b>{service}</b> 服务',
    discount: '折扣:',
    minutesAway: '分钟后',
    pickupDate: '挑个日子：',
    dropoffTime: '*放下： ',
    bookAdvance: '提前预定',
    mng: '见面和问候',
    complimentary: '免费的',
    viewMoreImgs: '查看更多图片',
    moreInfo: '更多信息',
    hideInfo: '隐藏信息',
    plusAppFees: '加上适用的费用',
    oneWayFare: '单程票价',
    downstairs: '楼下',
    upstairs: '楼上',
    advantage: '优势',
    stops: '停止',
    NA: '无法使用',
    availableFrom: '可从',
    availableUntil: '有效期至',
    daysLeft: '还剩天',
    timeLeft: '剩余时间',
    tryService2: '试试我们的 {service} 服务',
    wouldYouLike: '您想改用 <b>{service}</b> 吗？',
    yesChoose: '是的，选择 {service}',
    pickup: '捡起',
    extraStop: '加站',
    dropoff: '放下',
    sharedNotAllowed: '使用 加站 预订时不允许共享服务。',
    noService: '没有可用的服务。',
    noSelectedService: '没有选择的服务。',
    pickupTimeMustBe: '取件时间必须在 {time} 之后。'
  },
  customerForm: {
    yourInfo: '你的资料',
    emailExist: '该电子邮件已经存在于我们的系统中。如果您具有与提供的电子邮件关联的密码，请',
    clickHere: '点击这里',
    toSignIn: '登录',
    otherwisePlease: '否则，请提供您先前预订所使用的电话号码。',
    firstName: '名',
    lastName: '姓',
    iHaveWheelchair: '我有轮椅。',
    iHaveServiceDog: '我有一只服务犬。',
    previous: '以前的',
    serviceSelection: '服务选择',
    paymentDetails: '付款详情',
    signIn: '登入',
    enterEmail: '输入与您的帐户关联的电子邮件地址，我们将通过电子邮件向您发送一个链接，以重置您的密码。',
    sendReset: '发送重置密码',
    bookForSomeone: '我不是乘客我正在为其他人预订。',
    paxInfo: '旅客资讯',
    not: '不是',
    signOut: '登出',
    alreadyHave: '已经有帐号了？',
    signIn2: '登入',
    emailUsername: '电子邮件或用户名',
    forgotPass: '忘记密码？',
    corporateAccnt: '公司账户',
    createAccnt: '为我创建一个帐户，这样下次就不必重复此操作了。',
    passwordRequired: '密码字段是必填字段。',
    passwordNotMatch: '密码不匹配。',
    confirmEmail: '确认电子邮件'
  },
  driverReview: {
    thankYou: '感谢您与我们一起骑行！',
    ok: '好的',
    thankYouRating: '感谢您对这次旅行进行评分！',
    feedback: '您的反馈将帮助我们改善服务质量。',
    poor: '较差的',
    fair: '公平的',
    average: '平均',
    good: '好的',
    execellent: '出色的！',
    rateRide: '评价您的骑行',
    writeComments: '在这里写下您的意见，赞美或建议...'
  },
  global: {
    verify: '核实',
    verified: '已验证',
    changePhone: '更改电话号码',
    textPin: '一条短信已发送，密码为4位数字。请在下面的字段中输入图钉。',
    pin: '别针',
    loading: '载入中',
    resendPin: '重新发送图钉',
    fieldRequired: '此字段是必需的。',
    verifyFirst: '您需要先验证移动设备才能继续。',
    oops: '糟糕！出了些问题。请再试一遍。',
    invalidPin: '验证码无效。',
    dropoffEstimate: '* 下车时间是根据当前交通数据估算的。'
  },
  payment: {
    payment: 'Payment',
    cardEncrypt: '卡信息经过加密，安全和受保护。',
    selectCard: '请选择要使用的卡',
    directBill: '直接帐单',
    useNew: '使用新的信用卡',
    selectPayment: '请选择一种付款方式。',
    availablePayment: '可用的付款方式',
    nameOnCard: '卡片上的名字',
    isRequired: '这是必需的。',
    cardNumber: '卡号',
    exp: '截止日期',
    securityCode: '安全码',
    for: '为了',
    digitCard1: '卡 <i>背面</i> 上的3位数字。',
    digitCard2: '卡 <i>正面</i> 上的4位数字。',
    billingAddr: '帐单地址',
    city: '城市',
    state: '状态',
    chooseOne: '选一个',
    zip: '邮政编码',
    country: '国家',
    previous: '以前的',
    yourInfo: '你的资料',
    validating: '证实...',
    reviewBook: '复习并预订',
    followFormat: '请遵循格式',
    invalidExp: '无效的到期月份。',
    futureDate: '请输入将来的日期。',
    fare: '票价',
    airportFee: '机场费用：',
    fuelSurcharge: '燃油附加费',
    mng: '见面＆问候:',
    tip: '小费',
    credits: '学分:',
    redeem: '赎回',
    total: '全部的:',
    riderFee: '附加费',
    addTip: '添加提示',
    changeTip: '变更提示',
    enterTip: '输入提示。',
    promoCode: '促销代码',
    leg: '腿',
    custom: '风俗'
  },
  rsvpDetails: {
    hideTrip: '隐藏行程摘要',
    showTrip: '显示行程摘要',
    tripSummary: '行程摘要',
    serviceType: '服务类型',
    pickupType: '接送类型 ',
    edit: '编辑',
    startDate: '开始日期',
    pickupDate: '挑个日子',
    endDate: '结束日期',
    driverNotes: '驾驶员须知',
    aptGate: '公寓/门',
    flight: '飞行',
    curbside: '路边',
    mng: '见面＆问候',
    complimentary: '免费的',
    pickup: '捡起',
    extraStop: '加站',
    dropoff: '放下',
    inputNotes: '输入驱动程序说明'
  },
  review: {
    findingRide: '寻找你的旅程',
    lookNearby: '寻找附近的司机',
    busyDrivers: '看来我们的司机很忙。再试一次',
    sendingTo: '发送到',
    checking: '检查',
    sending: '正在发送',
    yourRequest: '你的申请',
    foundDriver: '我们找到了你一个司机！',
    driverOTW: '司机在路上。',
    trackTrip: '追踪您的旅行',
    close: '关闭',
    oops: '哎呀！出事了。请稍后再试。',
    goBack: '回去',
    creditCard: '信用卡',
    clickPay: '点击“付款”按钮，即表示您同意我们的',
    tos: '服务条款',
    sendEmail: '我们将发送确认电子邮件至',
    submittingRsvp: '提交预订',
    currentlySubmitting: '我们目前正在提交您的预订。',
    dontRefresh: '请不要离开或刷新此页面。',
    shouldntTake: '这不应该花很长时间。',
    successBooked: '您已成功预订了预订！',
    tyRsvp: '感谢您向我们预订。',
    weSentEmail: '我们已将确认电子邮件发送给',
    safelyClose: '您现在可以安全地关闭此页面，或通过单击返回到我们的网站',
    thisLink: '这个连结',
    unfortunately: '很遗憾，我们无法处理您的回程付款。您可以重试，然后单独预定回程。',
    subscribed: '已成功订阅我们的邮件列表。',
    subscribeMailing: '订阅我们的邮件列表以接收独家优惠和折扣。',
    subscribeNow: '现在订阅',
    reviewBook: '复习并预订',
    yourRsvp1: '这是您的预订号码',
    yourRsvp2: '这是您的预订号码',
    pay: '支付'
  },
  searchEdit: {
    editCancel: '编辑/取消您的预订',
    followInfo: '请输入以下信息以继续',
    isRequired: '这是必需的。',
    cannotFind: '找不到您的预订。',
    rsvpCompleted: '您的预订已经完成。',
    rsvpCancelled: '您的预订已被取消。',
    cannotEdit: '您无法编辑预订，因为您的司机已经在接您。',
    onboard: '您已经在机上，因此无法编辑您的预订。',
    rsvpDoesntExist: '该保留不存在。请检查您提供的信息，然后重试。',
    unassign: '取消分配驱动程序',
    alreadyAssigned: '您的预订已分配给驾驶员。为了编辑您的预订，我们需要先从驱动程序中取消分配。',
    confirmUnassign: '您要取消分配驱动程序并继续编辑预订吗？',
    yes: '是的，我愿意。',
    no: '不，我不想。',
    unassigning: '追踪您的车辆',
    rsvpNumber: '预约号码',
    firstName: '名',
    lastName: '姓'
  },
  searchTrack: {
    trackVehicle: '追踪您的车辆',
    followInfo: '请输入以下信息以继续',
    isRequired: '这是必需的。',
    rsvpCompleted: '您的预订已经完成。',
    rsvpCancelled: '您的预订已被取消。',
    rsvpDoesntExist: '该保留不存在。请检查您提供的信息，然后重试。',
    rsvpNumber: '预约号码',
    firstName: '名',
    lastName: '姓'
  },
  rsvpEdit: {
    convertCredit: '您可以选择将此游乐设施转换为骑乘积分。',
    convertDesc1: '这样，您的帐户将被记入贷方 ',
    convertDesc2: '您可以用来预订 ',
    convertDesc3: '您需要乘车时随时预订。',
    cxlFeeWillApply: '取消预订将收取手续费。',
    confirmConvert: '您想将其转换为乘车积分吗？',
    yes: '是的，我愿意。',
    no: '不，我想取消这趟旅程。',
    confirmCancel: '确认取消',
    whyCancel: '请告诉我们您为什么要取消此预订：',
    chooseOne: '选一个。',
    provideReason: '请提供您取消的原因。',
    yesCancel: '是的，取消我的预订',
    noCancel: '不，我改变了主意。',
    cancelRsvp: '正在取消预订...',
    rsvp: '预订',
    creditSuccess: '被成功记入。',
    cancelSuccess: '成功取消预订。',
    ok: '好的，我知道了。',
    oops: '哎呀！出事了。',
    tryAgain: '稍后再试。',
    reason1: '我错误地预订了这个',
    reason2: '我对价格不满意',
    reason3: '我对服务不满意',
    reason4: '我的计划改变了',
    reason5: '我的司机态度不好',
    reason6: '重复预订',
    reason7: '我的司机迟到了',
    reason8: '我的司机没有到达',
    reason9: '我叫了优步',
    reason10: '我坐了 Lyft',
    reason11: '我打了一辆出租车',
    reason12: '其他',
    cancelRsvp2: '您确定要取消预订吗？',
    chargeAmount: '取消此预订时，您将被收取 <b>$</b><strong>{amount}</strong> 取消费。<br/>您要继续吗？',
    custInfo: '客户资料',
    name: '姓名',
    phone: '电话',
    selectStartDate: '选择开始日期：',
    selectEndDate: '选择结束日期：',
    pickupDate: '选择接送日期：',
    arrivalDate: '选择您的航班到达日期',
    departureDate: '选择您的航班出发日期',
    selectStartTime: '选择开始时间：',
    selectEndTime: '选择结束时间：',
    arrivalTime: '选择您的航班到达时间',
    departureTime: '选择您的航班起飞时间',
    pickupTime: '选择接送时间：',
    setEndTime: '设置结束时间',
    setTime: '设定接送时间',
    applyTime: '申请时间',
    buffer1: '接送时间必须至少',
    buffer2: '分钟前。',
    EndDateMust: '结束日期必须晚于开始日期。',
    maxDurationFor: 'チャーター予約の最大期間は {time} です。',
    invalidDateRange: '日期范围无效。',
    driverNotes: '司机注意',
    saveNote: '保存笔记',
    removeNote: '删除笔记',
    emptyNotes: '笔记不能为空',
    chooseAirline: '从列表中选择一家航空公司：',
    chooseFlight: '从列表中选择您的航班',
    cantFindFlight: '我在清单上找不到我的航班。',
    fieldRequired: '此字段是必需的。',
    domesticFlight: '这是国内航班',
    lookingFor: '寻找',
    flights: '航班',
    whoBooking: '您为谁预订？',
    save: '救',
    bookForMyself: '我为自己预订。',
    nameRequired: '名和姓字段是必填字段。',
    editingRsvp: '编辑预约',
    rsvpDetails: '订房详情',
    pickupLoc: '接人的地方',
    addExtraStop: '添加额外的站点',
    extraStop: '加站',
    dropoffLoc: '下车地点',
    pickupTime2: '接送时间',
    UntilWhen: '你需要搭车到什么时候？',
    flightInfo: '航班信息',
    enterFlight: '输入您的航班信息',
    pax: '乘客人数',
    luggage: '行李',
    serviceType: '服务类型',
    saveBySharing: '通过分享您的旅程节省 {percent}%。',
    ifWeFind: '如果我们找到至少 1 个人与您分享您的行程，我们将退款给您',
    atTheTime: '在您的旅行结束时。',
    iWantToShare: '我想与其他人分享我的旅程',
    pickupType: '接送类型',
    mng: '见面＆问候',
    complimentary: '免费的',
    guestInfo: '客人信息',
    wheelchair: '轮椅',
    yes2: '是的',
    no2: '不',
    serviceDog: '服务犬',
    driverNote: '驾驶员注意',
    updateRsvp: '更新我的预订',
    cancelRsvp3: '取消我的预订',
    returnHome: '返回首页',
    missedSomething: '看起来您错过了一些东西。',
    gotIt: '好，我知道了。',
    suggestedPickupTime: '建议上车时间',
    suggesteDesc: '为确保我们能在您到达机场后立即接您，以下是建议的接送时间：',
    suggesteDesc2: '为确保您不会错过航班，建议的接载时间为：',
    suggestedYes: '是的，请使用建议的接送时间。',
    suggestedNo: '不，我想保留接送时间。',
    bookingForMyself: '我为自己预订',
    bookingFor: '预订',
    addDriverNote: '为您的驱动程序添加注释。',
    terminal: '终端',
    provideFlightInfo: '请提供您的航班信息以继续。',
    noServiceSelected: '没有选择服务。',
    serviceAccomodate1: '您选择的服务无法使用',
    serviceAccomodate2: '乘客。<br/>请选择其他服务类型以继续。',
    serviceAccomodate3: '行李。<br/>请选择其他服务类型以继续。',
    pickupTimeMust: '上车时间必须至少提前 {buffer} 分钟。',
    pleaseSetEnd: '请设置您的结束日期。',
    typeLocation: '输入您的{location}位置。',
    removeExtraStop: '删除额外停止',
    extraStop2: '加站',
    pickup: '捡起',
    dropoff: '放下',
    pickupLocation: '接人的地方',
    dropoffLocation: '下车地点',
    sorry: '对不起',
    couldntLocate: '我们找不到',
    paymentInfo: '支付信息',
    ccUsed: '使用的信用卡：',
    paidThru: '通过其他方式支付。',
    fare: '票价:',
    airportFee: '机场费用：',
    fuelSurcharge: '燃油附加费：',
    tip: '小费:',
    creditUsed: '使用的积分：',
    total: '全部的:',
    travelInsu: '旅游保险',
    startDate: '开始日期',
    pickupDate2: '挑个日子',
    availableOnlyFrom: '仅可从',
    chooseService: '选择一项服务：',
    doYouWant: '你想和别人分享你的旅程吗？',
    yesIWantToShare: '是的，我想与其他人分享我的旅程',
    noThanks: '不，谢谢。',
    NA: '无法使用',
    availableFrom: '可从',
    availableUntil: '有效期至',
    tryOur: '试试我们的',
    service: '服务',
    serviceAvailable: '该服务仅在机场提供',
    to: '到',
    serviceAirportPickup: '服务目前不适用于机场接送。',
    wouldYouLike: '你要试试吗',
    instead: '反而？',
    yes3: '是的，选择',
    changePickupTime: '我将更改接送时间',
    confirmUpdate: '确认更新',
    updateRsvp2: '您确定要更新您的预订吗？',
    yesUpdate: '更新我的预订',
    updatingRsvpp: '正在更新预订...',
    successUpdate: '已成功更新预订。',
    okUpdate: '好的，我知道了。',
    failUpdate: '无法更新您的预订。我们无法处理您的付款信息。',
    dueCharged: '由于您对预订进行了更改，因此需要向您收取额外费用',
    yourCard: '到您的信用卡。',
    dueRefund: '由于您对预订所做的更改，您将获得退款',
    typeNote: '在此处输入注释',
    search: '搜索...',
    typeFlight: '输入您的航班号。',
    firstName: '名',
    lastName: '姓',
    phoneNumber: '电话号码',
    forRsvpInfo: '如需预订信息更新，请取消此预订并重新预订。',
    riderFee: '附加费'
  },
  rsvpTrack: {
    rsvpDetails: '订房详情',
    pickupLoc: '接人的地方',
    extraStop: '加站',
    dropoffLock: '下车地点',
    pickupTime: '接送时间',
    endTime: '时间结束',
    flightInfo: '航班信息',
    noFlightInfo: '没有航班信息',
    pax: '乘客人数',
    luggage: '行李',
    serviceType: '服务类型',
    pickupType: '接送类型',
    mng: '见面＆问候',
    guestInfo: '客人信息',
    wheelchair: '轮椅',
    yes: '是的',
    no: '不',
    serviceDog: '服务犬',
    driverNote: '驾驶员注意',
    bookForMyself: '我为自己预订',
    bookFor: '预订',
    noDriverNotes: '没有驱动程序注释。',
    terminal: '终端',
    eta: '预计到达时间：',
    yourDriver: '您的司机',
    noDriverYet: '看起来您还没有驱动程序。',
    driverCheckAgain: '请在提货时间前一（1）小时再次检查一次。',
    phone: '电话号码：',
    email: '电子邮件地址：',
    driverLicense: '驾驶证号：',
    bestExp: '为了获得最佳体验，请使用下面的按钮下载{brandName}移动应用。',
    appStore: '应用商店',
    playStore: '应用商店',
    trackRsvp: '跟踪预约',
    returnHome: '返回首页'
  },
  events: {
    sentPassword: '我们向您发送了密码恢复电子邮件',
    invalidPromo: '促销代码无效。',
    successRedeem: '成功兑换',
    invalidDiscount: '您输入的代码无效。',
    expiredDiscount: '代码已过期：您输入的代码已过期。'
  },
  progressbar: {
    chooseRide: '选择你的游乐设施',
    enterDetails: '输入您的详细信息',
    paymentDetails: '付款详情',
    reviewBook: '复习并预订'
  },
  backend: {
    "There is no service available": "目前没有可用服务。",
    "Out of coverage area": "超出覆盖范围",
    "Trip is currently under auto-dispatch": "行程目前正在自动调度中。",
    "Invalid token": "令牌无效。",
    "Authentication error": "授权错误。",
    "Corporate profile is not associated with a customer account": "公司资料未与客户帐户关联",
    "Authentication error. Invalid token": "授权错误。令牌无效。",
    "Authentication error. Account may have been logged in on another device": "授权错误。帐户可能已在另一台设备上登录。",
    "Account is disabled": "帐户被禁用",
    "Cannot determine pricing": "无法确定价格",
    "This geofence does not support ASAP trips": "该地理围栏不支持ASAP旅行",
    "Cons Auth": "缺点验证",
    "Consumer account is disabled": "消费者帐户已禁用",
    "Unable to use the credit card selected": "无法使用所选的信用卡",
    "No payment options selected": "未选择付款方式",
    "Please enter a valid tip": "请输入有效的提示",
    "Unable to fetch pricing": "无法获取价格",
    "This geofence does not support future reservations": "该地理围栏不支持将来的预订",
    "Invalid payment calculation": "无效的付款计算",
    "Invalid pickup time": "无效的接送时间",
    "Invalid payment calculation!": "付款计算无效！",
    "Invalid payment calculation!!": "付款计算无效！！",
    "Invalid reservation": "无效的预订",
    "Unable to edit reservation of another brand": "无法编辑其他品牌的预订",
    "ERR_EDIT_RESTRICTED', 'Reservation cannot be edited anymore": "ERR_EDIT_RESTRICTED'，'无法再编辑预订",
    "Cannot display brand": "无法显示品牌",
    "Unknown trx ID": "未知的TRX ID",
    "Cant get consumer login": "无法获得消费者登录",
    "Cant get consumer connection": "无法与消费者建立联系",
    "Brand is required": "品牌为必填项",
    "No phone number": "没有电话号码",
    "Error finding corporate token": "查找公司令牌时出错",
    "Invalid corporate token": "无效的公司令牌",
    "Error finding corporate profile": "查找公司资料时出错",
    "Corporate profile not found": "找不到公司资料",
    "Error finding corporate device": "查找公司设备时出错",
    "Corporate device not found": "找不到公司设备",
    "Dispatch view requires [since]": "派遣视图需要[自]",
    "Dispatch view requires [until]": "派遣视图需要[直到]",
    "Date range is required to filter": "需要过滤日期范围",
    "Trip requires wheelchair lift": "旅行需要轮椅升降。",
    "Trip requires service dog": "旅行需要服务犬。",
    "Trip requires military clearance": "旅行需要军事许可。",
    "Unable to mark as arrived, current location is not yet near the pickup": "无法标记为已到达，当前位置尚未在皮卡附近",
    "ERR_RESTRICTED_GEOFENCE', 'You cannot view available reservations on a restricted area": "ERR_RESTRICTED_GEOFENCE'，'您无法在限制区域上查看可用的预订",
    "Unable to mark as complete, current location is not yet near the dropoff": "无法标记为已完成，当前位置尚未到达下达地点",
    "cannot get staging lot queue": "无法获得暂存批次队列",
    "cannot find drivers": "找不到驱动程序",
    "cannot find staging lots": "找不到分期付款",
    "Cannot find driver": "找不到驱动程序",
    "Cannot find driver's services": "找不到司机的服务",
    "Only transport drivers are allowed at the moment": "目前仅允许运输司机",
    "First Name is required": "名字为必填项",
    "Last Name is required": "必须填写姓氏",
    "Password is required": "密码是必需的",
    "Mobile Phone is required": "需要手机",
    "Requires lat": "需要纬度",
    "Requires lng": "需要lng",
    "Requires radius": "需要半径",
    "Package has already been accepted by a driver": "包已被驱动程序接受。",
    "Package is currently under auto-package": "软件包当前处于自动打包状态。",
    "Package does not contain any reservations": "套餐不包含任何预订",
    "cannot find provider": "找不到提供者",
    "Cannot find driver's vehicle": "找不到驾驶员的车辆",
    "cannot get provider's enabled services": "无法获得提供商的已启用服务",
    "Driver cannot accept shared packages": "驱动程序无法接受共享软件包",
    "Vehicle is not equipped with wheelchair lift": "车辆未配备轮椅升降机",
    "Vehicle cannot accommodate a service dog": "车辆无法容纳服务犬",
    "Vehicle cannot accommodate a military clearance": "车辆无法容纳军事许可",
    "Package geofence does not support TNC": "软件包地理围栏不支持TNC",
    "Package geofence does not support TCP": "软件包地理围栏不支持TCP",
    "Driver does not have availability at the reservation's time": "司机在预订时没有空房",
    "Trip is not available anymore": "旅行不再可用。",
    "Driver cannot accept this service type": "驱动程序无法接受此服务类型",
    "gg": "天",
    "Driver is not on duty": "司机不在值班",
    "Cannot get tracks list": "无法获取曲目列表",
    "Cannot get geofence list": "无法获取地理围栏列表",
    "Invalid reset password key": "无效的重置密码密钥",
    "Unable to find directions": "找不到方向",
    "Unable to find directions for the specified pickup and dropoff": "无法找到指定接送的路线",
    "E_CANNOT_LOGIN": "E_CANNOT_LOGIN",
    "E_EMAIL_EXISTS": "E_EMAIL_EXISTS",
    "User not found": "找不到使用者",
    "Parameters [contactID] must be an array": "参数[contactID]必须是一个数组",
    "Cannot find phone numbers": "找不到电话号码",
    "package items required": "所需包装物品",
    "Part of the packages to be merged are already assigned to a driver": "要合并的部分软件包已分配给驱动程序",
    "Part of the reservations are already assigned to a driver": "部分预订已分配给驾驶员",
    "Phone number already exists": "电话号码已存在",
    "Unable to find pickup geofences": "找不到拾音器地理围栏",
    "Unable to find dropoff geofences": "找不到下垂的地理围栏",
    "Services unavailable": "服务不可用",
    "Tip has already been given beforehand": "提示已经事先给出",
    "Consumer card not available": "消费卡不可用",
    "rsvp not found": "找不到rsvp",
    "No card that can be charged using stripe": "没有可以使用条带化的卡",
    "Credit card cannot be found anymore": "找不到信用卡",
    "rsvpId is required": "rsvpId是必需的。",
    "Schedule not found": "找不到时间表",
    "Schedule items not found": "找不到时间表项目",
    "Schedule assigned to other driver": "时间表分配给其他驱动程序",
    "Schedule is not available anymore": "日程不再可用",
    "Invalid fare matrix. Please contact administrator": "无效的票价矩阵。请与管理员联系。",
    "Unable to get vehicle for provider": "无法获得供应商的车辆",
    "Driver is not TNC": "驱动程序不是TNC",
    "requires ID": "需要ID",
    "1.0 Cannot updated customer profile": "1.0无法更新客户资料",
    "1.0 Cannot create stripe profile": "1.0无法创建条纹配置文件",
    "Forbidden": "禁止的",
    "No drivers to send": "没有要发送的驱动程序",
    "Invalid password recovery token": "无效的密码恢复令牌",
    "Cannot find admins": "找不到管理员",
    "Unable to find filter": "找不到过滤器",
    "Please leave a note when marking an RSVP as complete": "将RSVP标记为完成时，请留下笔记",
    "Notes are required when cancelling reservation": "取消预订时需要注意",
    "Reservation not found": "找不到预订",
    "Unknown charge identifier": "未知的费用标识符",
    "Invalid charge amount": "无效的收费金额",
    "403 Forbidden": "403禁止",
    "Unable to get autodispatch triggers": "无法获取自动调度触发器",
    "Unable to get autodispatch logs": "无法获取自动调度日志",
    "Unable to break a package that is already assigned to a driver": "无法破坏已经分配给驱动程序的软件包",
    "Driver not subscribed to notifications": "驱动程序未订阅通知",
    "Corporate Username already exists": "公司用户名已存在",
    "Unable to create profile info": "无法创建个人资料信息",
    "Username already exists": "此用户名已存在",
    "Invalid corporate profile": "无效的公司资料",
    "Corporate profile is not linked to a customer account": "公司资料未链接到客户帐户",
    "Invoice not found": "找不到发票",
    "Unable to check for invoice date conflicts": "无法检查发票日期冲突",
    "Failed to create invoice": "无法创建发票",
    "Cannot refresh invoice information": "无法刷新发票信息",
    "Cannot find ads": "找不到广告",
    "No currently running ad": "当前没有正在投放的广告",
    "Username is required": "用户名为必填项",
    "Token is required": "令牌为必填项",
    "Error trying to find corporate account": "尝试找到公司帐户时出错",
    "Invalid corporate account": "无效的公司帐户",
    "Corporate account is disabled": "公司帐户已禁用",
    "Unable to get nearby drivers": "无法找到附近的司机",
    "flight not found": "找不到航班",
    "[services] is required": "[服务]为必填项",
    "[services] needs to be an array": "[服务]必须是一个数组",
    "[props] is required": "[道具]为必填项",
    "no consumer to notify": "没有消费者通知",
    "invalid consumer id": "无效的消费者ID",
    "not found": "未找到",
    "Unable to get credit card list": "无法获得信用卡清单",
    "Catd not found": "找不到猫",
    "Action unauthorized for non-drivers": "非驾驶员的未经授权的行动",
    "Your driver account is not active. Action is restricted": "您的驱动程序帐户无效。行动受到限制。",
    "The reservation has already been canceled": "预订已被取消",
    "Please enable your location tracking to be able to start trip": "请启用您的位置跟踪才能开始旅行",
    "Unable to get your location": "无法获取您的位置。",
    "You can only start this trip once you are in the staging area": "您只有在登台区域后才能开始这次旅行",
    "Reservation is not yet completed": "预约尚未完成",
    "Invalid package": "无效的包裹",
    "Unauthorized": "未经授权",
    "Shift not created": "没有创建班次",
    "Unable to find shift": "找不到班次",
    "Shift not found": "找不到班次",
    "Unable to find sector": "找不到部门",
    "Sector not found": "找不到部门",
    "Unable to find subsector": "找不到分部门",
    "Subsector not found": "找不到子行业",
    "Unable to find phone number for this provider": "找不到该提供商的电话号码",
    "Unable to find address for this provider": "找不到该提供者的地址",
    "This provider has no account yet": "该提供者还没有帐户。",
    "Cannot find external account for this provider": "找不到该提供商的外部帐户。",
    "No ongoing reservation": "没有正在进行的预订",
    "[geofenceId] needs to be passed as an array": "[geofenceId]需要作为数组传递",
    "Unable to find airport association": "找不到机场协会",
    "A KML File is required to activate this geofence": "需要KML文件才能激活此地理围栏",
    "Cannot find subgeofences": "找不到子地理",
    "No vehicles found for driver": "找不到驾驶员的车辆",
    "1.1 Cannot update customer profile": "1.1无法更新客户资料",
    "1.1 Cannot create stripe profile": "1.1无法创建条带配置文件",
    "Unknown reservation": "未知的预订",
    "Reservation is not scheduled to this time": "预定时间尚未预定",
    "Forbidden to view this reservation": "禁止查看此预订",
    "Reservation is not accepted by any provider yet": "尚未被任何提供商接受预订",
    "There is another reservation scheduled now": "现在有另一个预定",
    "A credit card is required": "需要信用卡",
    "Unable to find list of transactions": "找不到交易清单",
    "This reservation is not paid through other means": "此预订不通过其他方式支付",
    "Card not found": "找不到卡",
    "Unable to charge the card": "无法为卡充值",
    "Unable to charge the card. No result": "无法为卡充值。没有结果。",
    "Unable to charge the card. No ID": "无法为卡充值。没有ID。",
    "Notification token is required": "通知令牌为必填项",
    "Requires since parameter": "需要参数",
    "Requires until parameter": "需要直到参数",
    "no location": "没有位置",
    "Not allowed": "不允许",
    "Reservation is not yet complete": "预订尚未完成",
    "Reservation has already been reviewed": "预订已被审查",
    "Sector not created": "未创建部门",
    "Subsector not created": "未创建子部门",
    "[driverId] is required": "[driverId]为必填项",
    "Parameter [chargeFees] must be true or false only": "参数[chargeFees]只能为true或false",
    "Parameter [cancel] must be true or false only": "参数[cancel]只能为true或false",
    "Transaction has already been refunded": "交易已退款",
    "Unable to deduct credits": "无法扣除积分",
    "Parameter [amount] is required": "参数[金额]为必填项",
    "Unable to fetch import record": "无法获取导入记录",
    "Unable to determine pickup geofence": "无法确定皮卡的地理围栏",
    "Pickup location out of coverage area": "取件地点不在覆盖范围内",
    "Unable to determine dropoff geofence": "无法确定下垂地理围栏",
    "Dropoff location out of coverage area": "下车地点超出覆盖范围",
    "Attempting to { list: [], paging: {} } a non-array": "尝试{列表：[]，分页：{}}非数组",
    "Attempting to { list: [] } a non-array": "尝试{列出：[]}个非数组",
    "Bid has already been cancelled": "竞标已被取消",
    "Bid has already been accepted": "出价已被接受",
    "Unable to fetch drivers without business": "没有业务就无法获取驱动程序",
    "Unable to fetch driver list without business": "没有业务就无法获取驱动程序列表",
    "Brand is required for quotation": "报价需要品牌",
    "Pickup is required for quotation": "需要领取报价",
    "Dropoff is required for quotation": "需要下车报价",
    "No services available": "没有可用的服务",
    "Unable to fetch pickup types": "无法获取取件类型",
    "Unable to fetch services": "无法获取服务",
    "Unknown payout status": "未知的付款状态",
    "Destination account not found 1": "找不到目标帐户1",
    "Unknown payout status 2": "未知的付款状态2",
    "Unknown payout status 3": "未知的付款状态3",
    "Expired password recovery key": "过期的密码恢复密钥",
    "Charter service is not available for this area": "该地区不提供包车服务",
    'Invalid promo code': '促销代码无效。',
    'This promo code is only valid for new users': '此促销代码仅对新用户有效',
    'Promo already expired': '促销已经过期',
    "Payment method for this reservation is no longer available": "此预订的付款方式已不再可用",
    "Phone already in use. Please log in or reset your password": "电话已在使用。请登录或重置您的密码。"
  }
}



// WEBPACK FOOTER //
// ./src/lang/cn.js